function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettlement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 25.76,
    viewBox: "0 0 32 25.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10257",
    transform: "translate(-478 -283.24)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8879",
    transform: "translate(482 284)",
    style: {
      fill: "#00a6c2"
    },
    d: "M0 0h27v15H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8878",
    transform: "translate(479 287)",
    style: {
      fill: "#84e681"
    },
    d: "M0 0h27v15H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 849",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(496 295)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 850",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(489 291)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46275",
    d: "M101.614 69.043V56.678a2.074 2.074 0 0 0-2.072-2.072H74.83a2.074 2.074 0 0 0-2.072 2.072v.771h-.69A2.074 2.074 0 0 0 70 59.52v12.365a2.074 2.074 0 0 0 2.072 2.072h15.719a7.12 7.12 0 1 0 13.5-3.8 2.081 2.081 0 0 0 .324-1.111zM74.433 56.678a.4.4 0 0 1 .4-.4h24.709a.4.4 0 0 1 .4.4v11.566a7.148 7.148 0 0 0-1.088-.9V59.52a2.074 2.074 0 0 0-2.071-2.071H74.434zm-2.762 15.208V59.52a.4.4 0 0 1 .4-.4h1.528a.37.37 0 0 0 .057 0H96.78a.4.4 0 0 1 .4.4v6.988a7.126 7.126 0 0 0-.92-.248.837.837 0 0 0-.627-1.392h-1.512a.837.837 0 0 0-.627 1.392 7.136 7.136 0 0 0-5.673 6.021H72.067a.4.4 0 0 1-.4-.4zm23.2 6.8a5.451 5.451 0 1 1 3.848-1.6 5.445 5.445 0 0 1-3.848 1.6z",
    transform: "translate(408.004 228.634)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46276",
    d: "M251.632 173.414a4.531 4.531 0 1 0-1.327 3.2 4.525 4.525 0 0 0 1.327-3.2zm-4.526 2.852a2.853 2.853 0 1 1 2.015-.836 2.85 2.85 0 0 1-2.015.836z",
    transform: "translate(245.282 120.881)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46277",
    d: "m487.26 319.873-2.179-1.266v-2.952a.838.838 0 0 0-1.676 0v3.435a.838.838 0 0 0 .416.724l2.6 1.508a.838.838 0 1 0 .841-1.449z",
    transform: "translate(18.219 -16.709)",
    style: {
      fill: "#283045"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettlement);
export default __webpack_public_path__ + "static/media/Settlement.0e07111fb6633b9058b36aee071aeb33.svg";
export { ForwardRef as ReactComponent };